export default __webpack_public_path__ + "static/media/08.351fcca2.jpg";